import React from 'react'
import PropTypes from 'prop-types'
import { Box } from './'

const Indicator = (props) => (
  <Box
    group='b'
    className={`background-${props.type.background} ${props.className}gp-indicator  gp-text text-a color-f`}
    style={{ ...props.style, ...props.type.style }}
    {...props.events}
  >
    {props.type.value}
  </Box>
)

Indicator.propTypes = {
  className: PropTypes.string,
  type: PropTypes.object.isRequired,
  style: PropTypes.object
}

Indicator.defaultProps = {
  className: '',
  style: {},
  events: {}
}

export default Indicator
